if (!window.Eurus.loadedScript.has('product-cart.js')) {
  window.Eurus.loadedScript.add('product-cart.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xProductCart', (
        wrappringVariantId,
        engravingVariantId,
      ) => ({
        loading: false,
        errorMessage: false,
        mainHasError: false,
        buttonSubmit: "",
        error_message_wrapper: {},
        stopAction: false,
        insuranceVariantId: '',
        loadInsurance(id) {
          if (this.insuranceVariantId == '') {
            this.insuranceVariantId = id;
          }
        },
        scrollToAtcBtn(btnId) {
          const originalAtcBtn = document.querySelector(`#${btnId}`);
          originalAtcBtn.scrollIntoView({
            behavior: "smooth",
            block: 'center',
            inline: 'center'
          })
        },
        async isDuplicateItem(variantId, productId) {
          const RESTRICTED_PRODUCT_ID = '8647954858225';

          if (productId !== RESTRICTED_PRODUCT_ID) {
            return false;
          }

          const variantIdStr = String(variantId).trim();

          try {
            console.log('Checking for duplicate - variant ID:', variantIdStr, 'Product ID:', productId);

            // Fetch cart data from Shopify API
            const response = await fetch('/cart.js');
            const cartData = await response.json();

            console.log('Cart items from API:', cartData.items.length);

            if (cartData.items && cartData.items.length > 0) {
              for (let item of cartData.items) {
                const itemVariantId = String(item.variant_id).trim();
                console.log('Comparing variant ID:', itemVariantId, 'with', variantIdStr);
                if (itemVariantId === variantIdStr) {
                  console.log('Duplicate found!');
                  return true;
                }
              }
            }

            console.log('No duplicate found');
            return false;
          } catch (error) {
            console.error('Error in isDuplicateItem:', error);
            return false;
          }
        },
        showDuplicateError() {
          try {
            console.log('showDuplicateError called');

            // Try to use Alpine store
            let store = null;
            try {
              store = Alpine.store('xCartNoti');
            } catch (e) {
              console.log('Alpine store not available yet');
            }

            if (store && typeof store.open === 'function') {
              console.log('Using xCartNoti store');
              store.type = 'error';
              store.listItem = [{
                title: 'Item Already in Cart',
                message: 'Item already in cart. You cannot add more than 1 qty'
              }];
              store.open();
            } else {
              // Fallback: Show a simple toast notification
              console.log('Using fallback notification');
              this.showFallbackNotification();
            }
          } catch (error) {
            console.error('Error in showDuplicateError:', error);
            this.showFallbackNotification();
          }
        },
        showFallbackNotification() {
          console.log('showFallbackNotification called - creating notification');

          // Remove any existing notifications (all variants)
          document.querySelectorAll('[id^="duplicate-item-notification"]').forEach(el => {
            console.log('Removing existing notification:', el.id);
            el.remove();
          });

          // Create a simple notification element
          const notification = document.createElement('div');
          const notificationId = 'duplicate-item-notification';
          notification.id = notificationId;
          notification.style.cssText = `
            position: fixed;
            bottom: 20px;
            left: 20px;
            right: 20px;
            z-index: 999999 !important;
            background: white;
            border-left: 4px solid #d32f2f;
            padding: 16px 20px;
            border-radius: 8px;
            box-shadow: 0 4px 12px rgba(0,0,0,0.15);
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
            max-width: 400px;
            margin: 0 auto;
            animation: slideIn 0.3s ease-out;
            display: block !important;
            visibility: visible !important;
            opacity: 1 !important;
          `;

          const removeNotification = () => {
            if (notification.parentNode) {
              notification.style.animation = 'slideOut 0.3s ease-out';
              setTimeout(() => {
                if (notification.parentNode) {
                  notification.remove();
                }
              }, 300);
            }
          };

          notification.innerHTML = `
            <div style="display: flex; align-items: flex-start; gap: 12px;">
              <div style="color: #d32f2f; font-size: 20px; font-weight: bold; margin-top: 2px; flex-shrink: 0;">⚠</div>
              <div style="flex: 1;">
                <div style="font-weight: 600; color: #333; margin-bottom: 4px;">Item Already in Cart</div>
                <div style="color: #666; font-size: 14px; line-height: 1.4;">Item already in cart. You cannot add more than 1 qty</div>
              </div>
              <button type="button" style="background: none; border: none; font-size: 24px; cursor: pointer; color: #999; padding: 0; margin-left: 12px; flex-shrink: 0;">×</button>
            </div>
          `;

          // Add event listener to close button
          const closeBtn = notification.querySelector('button');
          closeBtn.addEventListener('click', removeNotification);

          // Add styles for animation
          if (!document.querySelector('style[data-notification-animations]')) {
            const styleEl = document.createElement('style');
            styleEl.setAttribute('data-notification-animations', '');
            styleEl.textContent = `
              @keyframes slideIn {
                from {
                  transform: translateX(-100%);
                  opacity: 0;
                }
                to {
                  transform: translateX(0);
                  opacity: 1;
                }
              }
              @keyframes slideOut {
                from {
                  transform: translateX(0);
                  opacity: 1;
                }
                to {
                  transform: translateX(-100%);
                  opacity: 0;
                }
              }
              @media (min-width: 768px) {
                #${notificationId} {
                  left: auto !important;
                  right: 20px !important;
                  max-width: 400px !important;
                }
              }
            `;
            document.head.appendChild(styleEl);
          }

          console.log('Appending notification to body');
          document.body.appendChild(notification);
          console.log('Notification appended, checking if in DOM:', document.getElementById(notificationId) ? 'YES' : 'NO');
          console.log('Notification visible:', window.getComputedStyle(notification).display);

          // Auto-remove after 5 seconds
          const timeoutId = setTimeout(removeNotification, 5000);

          // Clear timeout if manually closed
          closeBtn.addEventListener('click', () => {
            clearTimeout(timeoutId);
          });

          console.log('Fallback notification setup complete');
        },
        async addToCart(e, required, quickView, sticky) {
          this.loading = true;
          e.preventDefault();

          setTimeout(async () => {
            if (required) {
              var productInfo = this.$el.closest('.product-info');
              if(sticky){
                productInfo = document.querySelector('.product-info');
              }
              if (productInfo) {
                var propertiesInput = productInfo.querySelectorAll(`.customization-picker`);
                this.stopAction = false;
                let scrollStatus = false;
                
                propertiesInput.length && propertiesInput.forEach((input) => {
                  if (input.required && input.value.trim() == '' || input.classList.contains("validate-checkbox")) {
                    input.classList.add("required-picker");
                    this.stopAction = true;
                    if(!scrollStatus){
                      input.parentElement.querySelector('.text-required').scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                      });
                      scrollStatus = true;
                    }    
                  } else {
                    input.classList.remove("required-picker");
                  }                
                });              
              }
              if (this.stopAction) {
                setTimeout (() => {
                  this.loading = false;
                }, 500);
                return true;
              }
            }
            await Alpine.store('xCartHelper').waitForCartUpdate();
            window.updatingCart = true;

            if (this.$refs.engraving_text && engravingVariantId) {
              if (this.$refs.engraving_text.value.trim()) {
                if (!this.$refs.engraving_text.hasAttribute('name')) this.$refs.engraving_text.setAttribute('name', this.$refs.text_area_name.value);
              } else {
                if (this.$refs.engraving_text.hasAttribute('name')) this.$refs.engraving_text.removeAttribute('name');
              }
            }

            var productForm = this.$el.closest('.product-info') || this.$el.closest('form');
            let formData = new FormData(this.$refs.product_form);
            const productId = formData.get('product-id');
            const variantId = formData.get('id');

            const isDuplicate = await this.isDuplicateItem(variantId, productId);
            console.log('isDuplicate result:', isDuplicate);
            if (isDuplicate) {
              console.log('Duplicate detected, showing error and stopping add to cart');
              this.showDuplicateError();
              this.loading = false;
              window.updatingCart = false;
              console.log('Loading set to false, function returning');
              return;
            }

            var edt_element = productForm ? productForm.querySelector(`.hidden.cart-edt-properties-${productId}`) : null;
            if (edt_element) {
              edt_element.value = edt_element.value.replace("time_to_cut_off", Alpine.store('xEstimateDelivery').noti)
            }
            formData = new FormData(this.$refs.product_form);

            formData.append(
              'sections',
              Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            const newFormData = new FormData();
            for (let [key, value] of formData.entries()) {
              if (value !== '') {
                newFormData.append(key, value);
              }
            }

            // Custom SKU property injection - ensures properties are added
            // even if the hidden input was lost during variant change DOM swap
            try {
              const skuConfigEl = this.$refs.product_form?.querySelector('script[data-custom-sku-config]')
                || (productForm && productForm.querySelector('script[data-custom-sku-config]'))
                || document.querySelector('script[data-custom-sku-config]');
              if (skuConfigEl) {
                const skuConfig = JSON.parse(skuConfigEl.textContent);
                const currentVariantId = newFormData.get('id');
                const currentSku = skuConfig.variantSkuMap[currentVariantId] || '';
                if (currentSku) {
                  for (const list of skuConfig.lists) {
                    if (!list.propName || !list.propValue || !list.skus) continue;
                    const skuStr = ',' + list.skus.replace(/\s/g, '') + ',';
                    if (skuStr.includes(',' + currentSku + ',')) {
                      const propKey = `properties[${list.propName}]`;
                      // Only add if not already in formData from hidden input
                      if (!newFormData.has(propKey)) {
                        newFormData.append(propKey, list.propValue);
                      }
                      break;
                    }
                  }
                }
              }
            } catch(e) {
              console.error('Custom SKU property injection error:', e);
            }

            const match = document.cookie.match('(^|;)\\s*' + 'eurus_insurance' + '\\s*=\\s*([^;]+)');
            const linkedProductList = newFormData.getAll('properties[_linked_product_id][]');

            if (
              (this.$refs.gift_wrapping_checkbox && this.$refs.gift_wrapping_checkbox.checked && wrappringVariantId) || 
              (this.$refs.engraving_text && engravingVariantId && this.$refs.engraving_text.value.trim()) || 
              (this.insuranceVariantId && !localStorage.getItem('insuranceRemoved') && (!match || match[1].trim() === '')) || 
              (linkedProductList.length > 0)
            ) {
              const variantId = formData.get('id');
              const productTitle = productForm ? productForm.querySelector(`.product-variant-title-${formData.get('product-id')}-${variantId}`)?.textContent : null
              let additionalOptionData = [];
              if (this.$refs.gift_wrapping_checkbox && this.$refs.gift_wrapping_checkbox.checked && wrappringVariantId) {
                additionalOptionData.push(
                  {
                    id: wrappringVariantId,
                    quantity: 1,
                    parent_id: variantId,
                    properties: {
                      "For": productTitle
                    }
                  }
                );
              }
              if (linkedProductList.length > 0) {
                linkedProductList.forEach(val => {
                  additionalOptionData.push(
                    {
                      id: val,
                      quantity: 1,
                      parent_id: variantId,
                      properties: {
                        "For": productTitle
                      }
                    }
                  );
                });
              }
              if (this.$refs.engraving_text && engravingVariantId && this.$refs.engraving_text.value.trim()) {
                additionalOptionData.push(
                  {
                    id: engravingVariantId,
                    quantity: 1,
                    parent_id: variantId,
                    properties: {
                      "For": productTitle
                    }
                  }
                );
              }
              if (this.insuranceVariantId && !localStorage.getItem('insuranceRemoved') && (!match || match[1].trim() === '')) {
                additionalOptionData.push(
                  {
                    id: this.insuranceVariantId,
                    quantity: 1
                  }
                );
              }
              if (additionalOptionData.length !== 0) {
                additionalOptionData.forEach((item, index) => {
                  const base = `items[${index}]`;

                  newFormData.append(`${base}[id]`, item.id);
                  newFormData.append(`${base}[quantity]`, item.quantity);

                  if (item.parent_id) {
                    newFormData.append(`${base}[parent_id]`, item.parent_id);
                  }

                  if (item.properties) {
                    Object.entries(item.properties).forEach(([key, value]) => {
                      newFormData.append(`${base}[properties][${key}]`, value);
                    })
                  }
                })
              }
            }

            let resProductId;
            let productUrl;

            await fetch(`${Eurus.cart_add_url}`, {
              method:'POST',
              headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
              body: newFormData
            }).then(reponse => {
              return reponse.json();
            }).then(async (response) => {
              if (response.status == '422') {
                if (typeof response.errors == 'object') {
                  this.error_message_wrapper = response.errors;
                  document.querySelector('.recipient-error-message').classList.remove('hidden');
                } else {
                  this.errorMessage = true;
                  setTimeout(() => {
                    this.errorMessage = false;
                  }, 3000);
                  if(this.$refs.error_message){
                    this.$refs.error_message.textContent = response.description;
                  }
                  if(this.$refs.error_message_mobile){
                    this.$refs.error_message_mobile.textContent = response.description;
                  }
                }
                if (Alpine.store('xMiniCart')) {
                  Alpine.store('xMiniCart').reLoad();
                  document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
                }
              } else {  
                resProductId = response.product_id;
                productUrl = response.url.split("?")[0];

                if (Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable) {
                  Alpine.store('xCartNoti').setItem(response); 
                }
                document.querySelector('.recipient-error-message') ? document.querySelector('.recipient-error-message').classList.add('hidden') : '';
                this.error_message_wrapper = {};
      
                if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) {
                  Alpine.store('xQuickView').show = false;
                }
                Alpine.store('xPopup').close();
                document.dispatchEvent(new CustomEvent("eurus:video-popup:close-popup"));
                if((quickView && Alpine.store('xQuickView').buttonQuickView && Alpine.store('xQuickView').buttonQuickView.dataset.addAsBundle) || (!quickView && this.$refs.product_form && this.$refs.product_form.querySelector('[data-add-as-bundle="true"]'))) {
                  document.dispatchEvent(new CustomEvent("eurus:cart:add-as-bundle"));
                } else {
                  Alpine.store('xCartHelper').reRenderSections(response.sections);
                  if (!Alpine.store('xCartNoti') || !Alpine.store('xCartNoti').enable) {
                    Alpine.store('xMiniCart').openCart();
                  }               
                  Alpine.store('xCartHelper').currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span').innerHTML);
                  if (Alpine.store('xQuickView')) {
                    Alpine.store('xQuickView').openPopupMobile = false;
                  }
                  this.$el.closest('.choose-options')?.getElementsByClassName('js-close-button')[0].click();
                  this.$el.closest('.js-product-container')?.getElementsByClassName('js-close-button')[0].click();
                  document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
                  document.dispatchEvent(new CustomEvent("eurus:cart:redirect"));
                }
              }
            }).catch((error) => {
              console.error('Error:', error);
            }).finally(() => {
              window.updatingCart = false;
              document.dispatchEvent(new CustomEvent(`eurus:product-card:clear:${resProductId}`));
              this.loading = false;
              if ((quickView && Alpine.store('xQuickView').buttonQuickView && !Alpine.store('xQuickView').buttonQuickView.dataset.addAsBundle) || (!quickView && this.$refs.product_form && !this.$refs.product_form.querySelector('[data-add-as-bundle="true"]'))) {
                if(this.$refs.gift_wrapping_checkbox) this.$refs.gift_wrapping_checkbox.checked = false;
              }
              document.cookie = `eurus_insurance=${this.insuranceVariantId}; path=/`;  
            })
          }, 0)
        }
      }))
    });
  });
}
